export const Routes = {
	PAYMENT_SUCCESS: '/payment/success',
	PRO_PAYMENT_SUCCESS: '/payment/pro/success',
	PRO_PAYMENT_CANCEL: '/payment/pro/cancel',
	HOUSE_SETUP: '/setup',
	HOUSE_SETUP_NEW: '/setup/new',
	/** @deprecated Use propertyRoutes(publicId).dashboard instead */
	DASHBOARD: '/dashboard',

	/** @deprecated Use propertyRoutes(publicId).records instead */
	RECORDS: '/records',
	/** @deprecated Use propertyRoutes(publicId).schedule instead */
	MAINTENANCE: '/maintenance',
	PROPERTIES: '/properties',
	ADMIN_PROPERTIES: '/admin/properties',
	SERVICE_PROVIDERS: '/service-providers',

	/** @deprecated Use propertyRoutes(publicId).settingsSharing instead */
	SETTINGS_SHARING: '/settings/access',
	/** @deprecated Use propertyRoutes(publicId).settings instead */
	SETTINGS_PROPERTY: '/settings/property',

	ACCESS_REDEEM: '/access/redeem',
	LOGIN: '/login',
	LOGOUT: '/logout',
	REGISTER: '/register',
	FINALIZE_USER: '/finalize-user',
	TOS_ACCEPTANCE: '/tos-acceptance',
	FORGOT_PASSWORD: '/forgot-password',
	RESET_PASSWORD: '/reset-password',
	PROFILE: '/settings/profile',
	API_KEYS: '/settings/api-keys',
	OAUTH_CONSENT: '/oauth/consent',
	PROFILE_SETUP: '/profile-setup',
} as const;

/**
 * Returns all property-scoped route paths for a given public ID.
 * Use these instead of the deprecated flat Routes constants for any
 * route that belongs to a specific property.
 */
export const propertyRoutes = (publicId: string) => ({
	dashboard: `/property/${publicId}` as const,
	records: `/property/${publicId}/records` as const,
	schedule: `/property/${publicId}/schedule` as const,
	archive: `/property/${publicId}/archive` as const,
	settings: `/property/${publicId}/settings` as const,
	settingsAccess: `/property/${publicId}/settings/access` as const,
	settingsTransfer: `/property/${publicId}/settings/transfer` as const,
	serviceProviders: `/property/${publicId}/service-providers` as const,
	stagedDocuments: `/property/${publicId}/staged-documents` as const,
});

/**
 * Typed TanStack Router `to` strings for all property-scoped routes.
 * Use these instead of inlining '/property/$propertyPublicId/...' literals.
 */
export const PropertyRouteTo = {
	dashboard: '/property/$propertyPublicId' as const,
	records: '/property/$propertyPublicId/records' as const,
	schedule: '/property/$propertyPublicId/schedule' as const,
	archive: '/property/$propertyPublicId/archive' as const,
	settings: '/property/$propertyPublicId/settings' as const,
	settingsAccess: '/property/$propertyPublicId/settings/access' as const,
	settingsTransfer: '/property/$propertyPublicId/settings/transfer' as const,
	serviceProviders: '/property/$propertyPublicId/service-providers' as const,
	stagedDocuments: '/property/$propertyPublicId/staged-documents' as const,
};

/** All possible `to` values for property-scoped routes. */
export type PropertyRouteToValue = (typeof PropertyRouteTo)[keyof typeof PropertyRouteTo];

/**
 * Returns typed TanStack Router navigate options for a property-scoped route.
 * Defaults to the dashboard. Pass a PropertyRouteTo value as the second argument
 * to navigate to any other property route, and an optional search object to
 * override the default search params for that route.
 */
export const propertyNavigateOptions = (
	publicId: string,
	to: PropertyRouteToValue = PropertyRouteTo.dashboard,
	search: Record<string, unknown> = { questionId: undefined },
) => ({
	to,
	params: { propertyPublicId: publicId },
	search,
});
